export default __webpack_public_path__ + "static/media/android.ee1d9508.jpeg";